
import addressMixin from '@/mixins/addressMixin.js';
import { ArrowLeftIcon } from 'vue-feather-icons';
export default {
  name: 'CheckoutAddressList',
  mixins: [addressMixin],
  components: {
    ArrowLeftIcon,
  },
  methods: {
    selectAddress(address) {
      this.$emit('onSelect', address);
    },
  },
};
